export default {
    en: {
        loadingDots: 'Loading ...',
        back: 'Back',
        start: 'Start',
        continue: 'Continue',
        edit: 'Edit',
        delete: 'Delete',
        move: 'Move',
        skip: 'Skip',
        remove: 'Remove',
        confirm: 'Confirm',
        cancel: 'Cancel',
        resend: 'Resend',
        search: 'Search',
        send: 'Send',
        update: 'Update',
        submit: 'Submit',
        evaluate: 'Evaluate',
        next: 'Next',
        finish: 'Finish',
        close: 'Close',
        save: 'Save',
        apply: 'Apply',
        sucessNotificationTitle: 'Success!',
        warningNotificationTitle: 'Warning!',
        errorNotificationTitle: 'Error!',
        help: 'Help',
        endConversation:
            'Are you sure you want to end the conversation at this point? Ending now means that your current responses will be used for evaluation.',
        continueConversation: 'Continue conversation',
        endConversationButton: 'End now',
        you: 'You',
        yes: 'Yes',
        no: 'No',
        loadingMessages: ['Loading ...', 'Getting things ready for you ...', 'Piecing things together ...'],
        loadingMessagesReportGeneration: [
            'Analyzing your responses ...',
            'Calculating the result ...',
            'Generating the feedback ...',
        ],
        manageDependencies: 'Manage dependencies',
        assignUsers: 'Assign users',
        assignOrganizations: 'Assign organizations',
        assignCompetencies: 'Assign competencies',
        loadingVideo: 'loading video',
        loadingAIContent: ['Generating the content ...'],
        unsavedChanges: 'You have {count} unsaved changes. Are you sure you want to leave?',
        contentOverridesDefaults: {
            course: { singular: 'course', plural: 'courses' },
            subCourse: { singular: 'sub-course', plural: 'sub-courses' },
            activity: { singular: 'activitiy', plural: 'activities' },
            task: { singular: 'task', plural: 'tasks' },
        },
        app: {
            navigation: {
                help: 'Help',
                faq: 'FAQ',
                takeATour: 'Take a tour',
                simulations: 'Simulations',
                competencies: 'Competencies',
                departments: 'Departments',
                challenges: 'Challenges',
                courses: 'Courses',
                dashboard: 'Dashboard',
                progressReport: 'Progress Report',
                report: 'Reports',
                assessments: 'Assessments',
                users: 'Users',
                editAccount: 'Edit account',
                signOut: 'Sign out',
                toggleNavigation: 'Toggle navigation',
                displaySettings: 'Display settings',
                contactOrganization: 'Contact {organization}',
                organizations: 'Organizations',
                organization: 'Your Organization',
                organizationGeneralSettings: 'Settings',
                organizationBranding: 'Branding',
                admin: 'Admin',
                app: 'App',
                shareFeedback: 'Share feedback',
                documents: 'Documents',
                reportsAndAnalytics: 'Reports and Analytics',
                prompts: 'Prompts',
            },
            simulations: {
                pageSubtitle: 'Participate in simulations to assess your competencies.',
                noSimulations: 'No simulations available',
                startSimulation: 'Start simulation',
            },
            prompts: {
                pageSubtitle: 'Create and manage prompts.',
                errorDownloadingPrompt: 'Error downloading prompt',
                errorUpdatingPrompt: 'Error updating prompt',
            },
            competencies: {
                pageSubtitle: 'See your progress across different competencies.',
                overview: 'Overview',
                strengthAreas: 'Areas of strength',
                improvementAreas: 'Areas for improvement',
                yourCompletedAssessments: 'Your completed assessments',
                noAssessments: 'No assessments available',
                viewReport: 'View report',
                showAll: 'Show all',
                showLess: 'Show less',
                searchByName: 'Search by name',
                openCompetency: 'Open competency',
                addCompetency: 'Add competency',
                competencyName: 'Competency Name',
                competencyNamePlaceholder: 'Enter the name of the competency',
                competencyDescription: 'Competency Description',
                competencyDescriptionPlaceholder: 'Enter the attributes associated with the competency',
                competencyCode: 'Competency Code',
                competencyCodePlaceholder: 'Enter the code of the competency',
                noCompetencies: 'No competencies found',
                noCompetencyClusters: 'No competency clusters found',
                competencyClusterPlaceholder: 'Select the competency cluster for the competency',
                competency: 'Competency',
                code: 'Code',
                title: 'Title',
                allCompetencies: 'All competencies',
                addCompetencies: 'Add competencies',
                competencyCluster: 'Competency cluster',
                competencyClusters: 'Competency clusters',
                addCompetencyMapping: 'Add competency mapping',
                createNewCompetency: 'Create new competency',
                selectExistingCompetencies: 'Select existing competencies',
                parentCompetencyCluster: 'Parent competency cluster',
                competencyClusterCode: 'Competency cluster code',
                competencyClusterCodePlaceholder: 'Unique code of the competency cluster',
                competencyClusterName: 'Competency cluster name',
                manageAssociatedClusters: 'Manage associated clusters',
                competencyClusterNamePlaceholder: 'Name of the competency cluster',
                description: 'Description',
                descriptionPlaceholder: 'Description of the competency cluster',
                deleteCompetencies: 'Delete competencies',
                confirmDeleteCompetencies: 'Are you sure you want to delete these {count} competencies?',
                cluster: 'Cluster',
                clusterPlaceholder: 'Select the cluster for the competency',
                viewCompetencies: 'View competencies',
                deleteCompetencyClusters: 'Delete competency clusters',
                confirmDeleteCompetencyClusters: 'Are you sure you want to delete these {count} competency clusters?',
                translateCompetency: 'Translate competency',
                competencyPlaceholder: 'Select a competency',
                behavioralIndicators: 'Behavioral indicators',
                addBehavioralIndicator: 'Add behavioral indicator',
                search: 'Search',
                behavioralIndicator: 'Behavioral indicator',
            },
            departments: {
                department: 'Department',
                departments: 'Departments',
                noDepartments: 'No departments found',
                selectDepartment: 'Select a department to view roles associated with it',
                departmentCode: 'Department Code',
                departmentCodePlaceholder: 'Unique code of the department',
                departmentName: 'Department Name',
                departmentNamePlaceholder: 'Name of the department',
                parentDepartment: 'Parent Department',
                roles: 'Roles',
                noRoles: 'No roles found',
                roleCode: 'Role Code',
                roleCodePlaceholder: 'Unique code of the role',
                roleName: 'Role Name',
                roleNamePlaceholder: 'Name of the role',
                roleDescription: 'Role Description',
                roleDescriptionPlaceholder: 'Key responsibilities and tasks this role involves',
                deleteRoles: 'Delete roles',
                deleteSuccessMessage: 'Deletion successful',
                roleFormTitle: 'Role Form',
                addRole: 'Add role',
                confirmDeleteRoles: 'Are you sure you want to delete these {count} roles?',
                searchByNameCode: 'Search by name or code',
                description: 'Description',
                assignCourses: 'Assign courses',
                selectRoleCompetencies: 'Select competencies for role {role}',
            },
            challenges: {
                pageSubtitle: 'Solve the challenges and improve your skills.',
                noChallenges: 'No challenges available',
                explanation: 'Explanation',
                week: 'Week',
                new: 'New',
                completed: 'Completed',
                doneCounter: '{done} / {total} done',
            },
            courses: {
                assignedCourses: 'Assigned courses',
                passed: 'Passed',
                failed: 'Failed',
                completed: 'Completed',
                retake: 'Retake',
                retakeIn: 'Retake in {time}',
                startTask: 'Start activity',
                resume: 'Resume',
                viewTasks: 'View activities',
                tasksCompleted: '{done} / {total} activities completed',
                courseStatusDraft: 'Draft',
                courseStatusReady: 'Ready',
                courseStatusScheduled: 'Scheduled',
                courseStatusActive: 'Active',
                courseStatusInactive: 'Inactive',
                courseStatusArchived: 'Archived',
                assessmentFeedback: {
                    yourPerformanceAssessment: 'Your Performance Assessment',
                    assessmentFeedback: 'Thank you for completing the activity. Here are your results.',
                    passedMessage: 'You have successfully achieved the passing score. Great job!',
                    failedMessage: 'Unfortunately, you have not achieved the passing score. ',
                    retakeFailedMessage: 'You can try again by retaking the activity.',
                    retakePassedMessage: 'You can retake the activity if you wish to further improve your result.',
                    feedbackMessage: `Please take a moment to review the feedback below. It provides clear and actionable insights on enhancing your skills and better prepare for the next assessment. If you have any questions or need further explanation about the feedback, please do not hesitate to contact us at <a href="mailto:{email}">{email}</a>.`,
                    feedback: 'Feedback',
                    score: 'Score',
                    criteria: 'Criteria',
                    expectation: 'Expectation',
                    criteriaFeedback: 'Criteria-based feedback',
                    responseFeedback: 'Response-level feedback',
                    thanksMessage: 'Thank you for completing the activity.',
                    submissionReviewMessage: 'Your submission is in evaluation. You will get the results after review.',
                    detailedFeedbackUnavailable: 'No detailed feedback available.',
                    clickHighlightedText:
                        'Click the highlighted areas of your response to point to the associated feedback.',
                },
                taskSubmissionError: 'An error occurred while submitting the activity. Please try again.',
                taskStartError: 'An error occurred while starting the activity. Please try again.',
                reportGenerationError:
                    'Thanks for your submission! Our evaluation system is currently handling a high volume of activity, so your result might take a bit longer to appear. Please check back in about an hour for your personalized report.',
                noReport: 'No report available',
                courseModuleCreatorAI: {
                    courseCreator: 'Course creator',
                    courseContext: 'Course context',
                    courseContent: 'Course content',
                    roles: 'Roles',
                    rolePlaceholder: 'Select appropriate roles for which the course is intended',
                    competencies: 'Competencies / Behavioral indicators',
                    selectCompetencies: 'Select competencies / behavioral indicators',
                    aboutCourse: 'Additional information about the course',
                    aboutCoursePlaceholder: 'Any additional information about the course that you want to add?',
                    intendedAudience: 'Target Audience',
                    intendedAudienceHint:
                        'This could include any characteristics that should be considered to tailor the topic to the target audience, such as:<br />• demographics,<br />• educational or professional characteristics, <br />• desired difficulty level, etc.',
                    intendedAudiencePlaceholder: 'Which group of people do you want to create the courses for?',
                    sourceDocuments: 'Source documents',
                    sourceDocumentsPlaceholder: 'Select documents (if any) for the course',
                    sourceDocumentsHint: 'Select the documents that you want to use as the basis for auto-generation',
                    generateLearningObjectives: 'Generate learning objectives',
                    selectedLearningObjective: 'Select learning objectives most suitable for the course',
                    createHeirarchy: 'Create sub-modules in the course for a logical course structure',
                    taskTypes: 'Task types',
                    taskTypesHint:
                        'Please note that this is just a preference. The AI may chose to create different types of task based on the rest of the information provided.',
                    taskTypesPlaceholder: 'Select your preferred types of task in the course',
                    language: 'Language',
                    difficultyLevel: 'Difficulty level',
                    beginner: 'Beginner',
                    intermediate: 'Intermediate',
                    advanced: 'Advanced',
                    createCourseOutline: 'Create course outline',
                    generateActivities: 'Generate activities',
                    courseOutline: 'Course outline',
                    createCourse: 'Create course',
                },
                activity: {
                    exitActivity: 'Exit activity',
                    goToActivity: 'Go to activity',
                    backTo: 'Back to {title}',
                    nextActivity: 'Next activity: {title}',
                    activityNotStarted: "Activity hasn't been started yet.",
                    leaveActivityConfirmation:
                        'Are you sure you want to leave the activity? Your changes will not be saved and you will lose your progress.',
                    tour: {
                        exitActivity:
                            'Use this option to leave the activity. Be aware that your responses will not be saved if you exit the activity without submitting.',
                        activityIntro:
                            'Start here to understand the goals, instructions, and key details for this activity.',
                        activityResources:
                            'Access supporting materials, reference documents, or helpful links related to the activity.',
                        activityArea:
                            "This is where the main content of the activity is displayed and where you'll complete the required tasks.",
                        activitySubmit:
                            "Once you've completed the activity, click this button to submit your responses.",
                    },
                },
            },
            faq: {
                pageTitle: 'Frequently Asked Questions (FAQs)',
                navigationPlatform: 'Navigating the platform',
                navigationPlatform_q1: 'How can I view resources like case studies while completing an activity?',
                navigationPlatform_a1:
                    'You can access supporting resources (such as case studies) from the <b>right-hand pane</b> during the activity.',
                navigationPlatform_q2: 'Can I refer to information from previous activities while doing a new one?',
                navigationPlatform_a2:
                    'Yes. When necessary, details from previous activities (e.g., your business objectives) will appear in the <b>right-hand pane</b> for easy reference.',
                navigationPlatform_q3: 'How can I see more of the activity on my screen?',
                navigationPlatform_a3:
                    'You can <b>expand the activity view</b> by collapsing both the <b>left and right panes</b> of the screen.',
                navigationPlatform_q4: 'How can I revisit the introduction or instructions for an activity?',
                navigationPlatform_a4:
                    'Click the <b>info icon</b> next to the activity name to view the introduction and task details at any time.',
                navigationPlatform_q5: 'Is there additional information available when completing an activity?',
                navigationPlatform_a5:
                    'Yes! Click the <b>question mark icon in a circle</b> for additional information about the activity.',
                navigationPlatform_q6: 'Can I adjust the text size for better readability?',
                navigationPlatform_a6:
                    'Yes. You can change the <b>text size</b> by going to the <b>Settings</b> section in your profile.',
                navigationPlatform_q7: 'Which browsers or devices are best for using the platform?',
                navigationPlatform_a7:
                    'For the best experience, use a <b>desktop or laptop</b> with the latest version of <b>Chrome, Firefox, or Edge</b>.',
                navigationPlatform_q8: "What should I do if the platform freezes or doesn't load correctly?",
                navigationPlatform_a8:
                    'Try refreshing the page or checking your internet connection. If the problem continues, contact <b>technical support</b>.',
                takingActivities: 'Taking activities',
                takingActivities_q1: 'What should I expect before starting a task?',
                takingActivities_a1:
                    "Before entering a task, you'll be clearly informed about:<br />• What you're expected to do<br />• How your performance will be evaluated",
                takingActivities_q2: 'Do any activities contain multiple tasks?',
                takingActivities_a2:
                    'Yes. Some activities include <b>multiple tasks</b>. You can move to the next task by clicking the <b>Continue</b> button.',
                takingActivities_q3: 'When can I submit an activity for evaluation?',
                takingActivities_a3:
                    'The <b>Submit/Evaluate</b> button becomes active <b>only after all required fields</b> in the activity have been completed.',
                takingActivities_q4: 'Do I need to complete the activities in a specific order?',
                takingActivities_a4:
                    'Yes, the sequence of courses and activities to be completed is on the dashboard. When all of the activities in the first course are completed, the next course on the dashboard becomes available.',
                takingActivities_q5: 'How long does it take to complete an activity?',
                takingActivities_a5:
                    'Depending on the scope of the activity, it may take just a few minutes or longer to complete each activity.',
                takingActivities_q6: 'What happens if I run out of time before completing an activity?',
                takingActivities_a6:
                    "If you run out of time, it is counted as a <b>failed attempt</b>, and you'll need to <b>retake the activity<b> after the 72-hour waiting period.",
                takingActivities_q7:
                    'What happens if I exit the activity area before submitting it, for example by hitting the "back button"?',
                takingActivities_a7:
                    'On exiting the activity before submitting it, your responses will not be saved and you will lose your progress. If you accidentally exit, you will be shown a dialog asking you to confirm leaving the page. You can click on ‘Cancel’ to stay and continue working on the activity.',
                scoringFeedback: 'Scoring & feedback',
                scoringFeedback_q1: 'What is the minimum passing score for an activity?',
                scoringFeedback_a1: 'You need to score <b>at least 3 out of 5</b> to pass an activity.',
                scoringFeedback_q2: 'What if I score below 3/5 on an activity?',
                scoringFeedback_a2:
                    'Once all of the courses/activities for the first attempt have been submitted, any activities that are below the passing score are eligible for an immediate retake with a new 72 hour window to complete. If an activity fails a second time, a retake is available after a 72 hour wait period from the completion of the last attempt of failed activities.',
                scoringFeedback_q3: 'Can I retake an activity to improve my score if I already passed?',
                scoringFeedback_a3:
                    "No. Once you've passed an activity (score of 3/5 or higher), <b>retakes are not allowed</b> unless specifically permitted by your program.",
                scoringFeedback_q4: 'How will my activity be evaluated once I submit it?',
                scoringFeedback_a4:
                    "Your submission is reviewed according to the <b>PGA's skill standards</b>, and you'll receive a <b>score and detailed feedback</b>.",
                scoringFeedback_q5: 'What kind of feedback will I receive?',
                scoringFeedback_a5:
                    "You'll get two types of feedback:<br />• <b>Criteria-level feedback</b>: How well you performed on each evaluation criterion<br />• <b>Response-level feedback</b>: Specific comments on the answers you provided",
                scoringFeedback_q6: "What if my feedback doesn't show after submitting an activity?",
                scoringFeedback_a6:
                    "If feedback doesn't appear right away, the system might be processing your results. Please <b>check back in about an hour</b> — the system will generate and display your report by then.",
                trackingProgress_q1: 'How can I track my overall progress?',
                trackingProgress: 'Tracking your progress',
                trackingProgress_a1:
                    'Use the <b>Progress Report</b> to:<br />• View your completed activities<br />• Access scores and feedback<br />• Get recommendations on what to do next<br />• Use quick links to revisit any activity',
                trackingProgress_q2: "Where can I view all the activities I've started or completed?",
                trackingProgress_a2:
                    'Your dashboard shows all current, pending, and completed activities with their status and progress.',
                trackingProgress_q3: 'Can I update my personal information or email on the platform?',
                trackingProgress_a3:
                    'Yes. Go to your <b>profile or settings section</b> to update your details at any time.',
                accountAccess: 'Account & access',
                accountAccess_q1: 'How do I log in for the first time?',
                accountAccess_a1:
                    "You will receive login credentials via email. Use those to sign in to the platform. If you haven't received them, please check your spam folder or contact support.",
                accountAccess_q2: 'What should I do if I forget my password?',
                accountAccess_a2: 'Click <b>"Forgot Password?"</b> on the login page to reset your password via email.',
            },
            platformTour: {
                dashboard: 'This is your main hub for navigating the platform.',
                progressReport: 'Track your progress and view feedback on your completed activities.',
                profileSettings: 'View and update your personal information and account settings.',
                courses: 'View and access the courses and activities assigned to you here.',
                help: 'Find answers to frequently asked questions, explore helpful resources, or contact support.',
                displaySettings: 'Adjust your display settings such as text size from here.',
            },
            dashboard: {
                successfullyCompletedTasks: 'Completed activities',
                tasksToRetake: 'Activities to retake',
                tasksToResume: 'Activities to resume',
                scoreOnLatestTask: 'Score on latest activity',
                recentTasks: 'Recent activities',
                recommendedTasks: 'Recommended activities',
                recommendedSectionPlaceholder:
                    'Your recommended activities will appear here. Currently there are no recommendations.',
                readyToRetake: 'Ready to retake',
                // retakeSectionPlaceholder:
                //     'An activity becomes available for retake 48 hours after you last took it. Currently there are no activities for you to retake.',
                retakeSectionPlaceholder: 'Activities that are available for retake will appear here.',
                recentTasksPlaceholder: 'No activities taken recently.',
                retake: 'Retake',
                continue: 'Continue',
                start: 'Start',
                viewAll: 'View all',
                viewDetails: 'View details',
                passed: 'Passed',
                failed: 'Failed',
                allCompletedTasks: 'All completed activities',
                dashboardTour: {
                    recommendedTasks:
                        'View a list of suggested activities to take next. You can start any activity directly from here.',
                    retakeTasks: ' If retakes are allowed, activities available for retaking will appear here.',
                    recentTasks: "Review your performance and feedback on the most recent activities you've completed.",
                },
            },
            report: {
                viewSingleResult: 'View result',
                viewResult: 'View results',
            },
            sidePanelInfo: {
                resources: 'Resources',
            },
        },
        admin: {
            organizationsManagement: {
                pageSubtitle: 'Manage active organizations',
                noOrganizations: 'No organizations avaialble',
                createOrganization: 'New Organization',
                organization: 'organization | organizations',
                searchByName: 'Search by name',
                code: 'Code',
                name: 'Name',
                contactEmail: 'Contact Email',
                associatedDomains: 'Associated Domains',
                industry: 'Industry',
                organizationCode: 'Organization Code',
                organizationName: 'Organization Name',
                organizationContactEmail: 'Contact Email',
                organizationAssociatedDomain: 'Associated Domain',
                organizationIndustry: 'Industry/Sector',
                organizationNamePlaceholder: 'Enter the name of the organization',
                organizationContactEmailPlaceholder: 'Enter the email address of the organization admin',
                organizationAssociatedDomainPlaceholder: 'Enter the domains of the organization',
                organizationIndustryPlaceholder: 'Enter the industry of the organization',
                organizationCodePlaceholder: 'Enter the code of the organization',
                generalSettings: 'General',
                brandingSettings: 'Branding',
                organizationLogo: 'Logo',
                organizationLogoDark: 'Logo (dark)',
                organizationLogoLight: 'Logo (light)',
                brandingColors: 'Branding Colors',
                primaryColor: 'Primary Color',
                secondaryColor: 'Secondary Color',
                statusHeader: 'Status',
                organizationLogoPlaceholder: 'Upload the logo of the organization',
                suspendedAt: 'Suspended at',
                suspensionReason: 'Suspension reason',
                autoDeleteAt: 'Auto delete at',
                status: {
                    active: 'active',
                    suspended: 'suspended',
                },
                createNewOrganization: 'Create',
                editOrganization: 'Update',
                organizationCreateFailed: 'Organization creation failed',
                organizationDeleteFailed: 'Organization deletion failed',
                organizationEditFailed: 'Organization edit failed',
                organizationEditSuccess: 'Organization edited successfully',
                inviteUsers: 'Invite Users',
                deleteOrganization: 'Delete organization',
                confirmDeleteOrganization:
                    'Are you sure you want to delete this organization? Deleting the organization deletes all associated users, departments, courses and simulations and cannot be undone. | Are you sure you want to delete these {count} organizations? Deleting the organizations deletes all associated users, departments, courses and simulations and cannot be undone.',
                deleteOrganizationSuccess: 'Organization deleted successfully',
                organizationContactEmailHint: 'Enter the email address where users can contact the organization.',
            },
            organizationSettings: {
                deletionRequestSuccess: 'Organization deletion request sent successfully',
                deletionRequestError: 'Organization deletion request failed',
                dangerZone: 'Danger Zone',
                dangerZoneDescription:
                    'This action is irreversible and will delete the organization and all associated data. Please confirm your intent to proceed.',
                requestDeletion: 'Request deletion',
                deleteOrganization: 'Delete organization',
                deleteOrganizationDescription:
                    'Requesting deletion of your organization will log you out of the platform and all associated users will be removed. The organization will then be suspended and then be permanently deleted after 30 days or sooner by direct request, which will in turn delete all associated courses, simulations, and documents. All user information will be deleted from the platform if they are not also associated with another organization.',
                deleteOrganizationSuccess: 'Organization deletion request sent successfully',
                deleteOrganizationError: 'Organization deletion request failed',
                confirmationText: 'Confirmation text',
                confirmationTextPlaceholder: 'Type "DELETE" to confirm',
                deletionWarning:
                    'Deletion will log you out of the platform and all associated users will be removed. The organization will then be suspended and then be permanently deleted after 30 days or sooner by direct request, which will in turn delete all associated courses, simulations, and documents. All user information will be deleted from the platform if they are not also associated with another organization.',
                deletionReason: 'Deletion reason',
                deletionReasonPlaceholder: 'Enter the reason for deleting the organization',
                confirmDeletion: 'Confirm deletion request',
            },
            departmentsManagement: {
                departmentPlaceholder: 'Select a department',
                departmentRolePlaceholder: 'Select a department role',
            },
            simulationsManagement: {
                openSimulation: 'open simulation | open simulations',
                archivedSimulation: 'archived simulation | archived simulations',
                description: 'Manage active and archived simulations and create new ones.',
                simulationDefaultName: 'Simulation {nextSimulationNumber}',
                createSimulation: 'Create simulation',
                setUpSimulation: 'Set up a simulation',
                setUpSimulationSubtitle: 'Set up the name, start and end date of the simulation.',
                setUpTeams: 'Set up the teams',
                setUpTeamsSubtitle: 'Add the emails of the team members you want to invite to the simulation.',
                editSimulation: 'Edit simulation',
                editSimulationSubtitle: 'Edit the name, start and end date of the simulation.',
                editTeams: 'Edit teams',
                editTeamsSubtitle: 'Add the emails of the team members you want to invite to the simulation.',
                open: 'Open',
                archived: 'Archived',
                searchByName: 'Search by name',
                name: 'Name',
                enterName: 'Enter a name for the simulation',
                scenario: 'Scenario',
                loadingScenarios: 'Loading scenarios ...',
                selectScenario: 'Select a scenario',
                scenarioTeamsWarning: 'Warning: Changing the scenario will remove all users from the teams.',
                contentVariation: 'Content variation',
                defaultContent: 'Default',
                startDate: 'Start date',
                startDateDescription: 'The day when the simulation instance can be started.',
                startDateCannotBeEditedAfterStart: 'The start date can not be edited after the simulation has started.',
                numberOfTeamsCannotBeEditedAfterStart:
                    'The number of teams can not be edited after the simulation has started.',
                scenarioCannotBeEditedAfterStart: 'The scenario can not be edited after the simulation has started.',
                simulationCreated: 'The simulation has been created successfully.',
                simulationUpdated: 'The simulation has been updated successfully.',
                endDate: 'End date',
                endDateDescription: 'The day by the end of which the simulation instance should end.',
                enterMemberEmails: 'Enter member email addresses (Optional)',
                invalidEmailEntered: 'An invalid email address was entered.',
                emailAlreadyInUse: 'This email address is already used in team {team}.',
                addTeam: 'Add team',
                atLeastOneTeamRequired: 'At least one team is required.',
                scenarioNotLoadedYet: 'The scenario is not loaded yet.',
                saveWithoutSendingInvitations: 'Save without sending invitations',
                saveAndSendInvitations: 'Save and send invitations',
                saveSimulation: 'Save simulation',
                status: 'Status',
                activeStatus: 'Active',
                scheduledStatus: 'Scheduled',
                concludedStatus: 'Concluded',
                deleteSimulations: 'Delete simulations',
                confirmDeleteSimulations:
                    'Are you sure you want to delete this simulation? | Are you sure you want to delete these {count} simulations?',
                teamName: 'Team name',
                role: 'Role',
                accessCode: 'Access code',
                sendInvitations: 'Send invitations',
                resendInvitations: 'Resend invitations',
                allMembersInvited: 'All members have already been invited.',
                sendOnlyToUninvited: 'Send only to the participants that have not yet received an invitation',
                sendToAll: 'Send to all participants',
                invitationsWillBeSentTo: 'The invitation emails will be sent to:',
                invitationSentToAll: 'The invitation emails have been sent to all participants.',
                invitationSentToUninvited:
                    'The invitation emails have been sent to the participants that have not yet received an invitation.',
                invitationCouldNotBeSent: 'The invitation emails could not be sent.',
                sendReports: 'Send reports',
                resendReports: 'Resend reports',
                sendingReportsDots: 'Sending reports ...',
                reportsHaveBeenSent: 'Reports have been sent to the participants.',
                reportsHaveAlreadyBeenSent:
                    'Reports have already been sent out to all participants. Are you sure that you want to send them again?',
                noTeamMembersToSendReportsTo: 'There are no team members to send report emails to.',
                cannotSendReportsForScheduled: 'You can not send emails for scheduled simulations.',
                downloadReports: 'Download reports',
                generatingReportsDots: 'Generating reports ...',
                cannotDownloadReportsForScheduled: 'You can not download reports for scheduled simulations.',
                noTeamMembersToSendInvitationsTo: 'There are no team members to send invitation emails to.',
                cannotSendInvitationsForConcluded: 'You can not send invitation emails for concluded simulations.',
                archive: 'Archive',
                restore: 'Restore',
                viewAccessCodes: 'View access codes',
            },
            challengesManagement: {
                challenge: 'challenge | challenges',
                description: 'Generate and manage the continuous challenges that the learners have to face.',
                content: 'Content',
                files: 'Files',
                dropFiles: 'Drop PDF files here or click to upload',
                upload: 'Upload',
                integrations: 'Integrations',
                searchByText: 'Search by text',
                text: 'Text',
                status: 'Status',
                activeStatus: 'Active',
                unverifiedStatus: 'Unverified',
                answers: 'Answers',
                answersCount: 'answer | answers',
                createdAt: 'Created at',
                generate: 'Generate',
                generateChallenges: 'Generate challenges',
                verify: 'Verify',
                unverify: 'Unverify',
                contentFile: 'Content file',
                noContentFiles: 'No content files',
                selectContentFiles: 'Select content file',
                generatingChallenges: 'Generating challenges ...',
                challengesGenerated: 'Challenges successfully generated!',
                competencies: 'Competencies',
                noCompetencies: 'No competencies',
                difficulty: 'Difficulty',
                veryEasy: 'Very easy',
                easy: 'Easy',
                medium: 'Medium',
                hard: 'Hard',
                veryHard: 'Very hard',
                editChallenge: 'Edit challenge',
                enterChallengeText: 'Enter the text of the challenge',
                enterCompetencies: 'Enter the competencies of the challenge',
                atLeastOneAnswer: 'At least one answer is required.',
                atLeastOneCorrectAnswer: 'At least one correct answer is required.',
                answerOptions: 'Answer options',
                option: 'Option',
                isCorrect: 'Correct',
                addAnswer: 'Add answer',
            },
            reportingAndAnalytics: {
                reportingScopes: 'Reporting scopes',
                allCourses: 'All Courses',
                averageScore: 'Average Score',
                noScoreDataAvailable: 'No score data available for the selected criteria.',
                activityStatus: 'Activity Status',
                noActivityStatusDataAvailable: 'No activity status data available for the selected criteria.',
                assessee: 'Assessee | Assessees',
                viewAttempt: 'View attempt',
                searchBy: 'Search by user name, course name, or activity name',
                numberOfAssessees: 'Number of Assessees',
                scoreLabel: 'Score (out of 5)',
                scoreDistribution: 'Score Distribution',
                timePeriod: 'Time Period',
                user: 'User',
                users: 'Users',
                activityAttempts: 'Activity Attempts',
                totalAttempts: 'total attempts',
                noAttemptsFound: 'No attempts found',
                noActivityAttemptsFound: 'No activity attempts found for the selected filters.',
                assessmentFeedback: 'Assessment Feedback',
                userName: 'User Name',
                activityName: 'Activity Name',
                course: 'Course',
                status: 'Status',
                score: 'Score',
                feedback: 'Feedback',
                all: 'All',
                pending: 'Pending',
                started: 'Started',
                passed: 'Passed',
                failed: 'Failed',
                completed: 'Completed',
                averageScoreTooltip: 'This chart shows the average scores for activities by course.',
                activityStatusTooltip: 'This chart shows the status of the activity for the selected course.',
                numberOfUsers: 'Number of Users',
            },
            usersManagement: {
                user: 'user | users',
                description: 'Maintain the list of participants that can use the system.',
                descriptionAdmin: 'Maintain the list of participants, instructors, and admins that can use the system.',
                participants: 'Participants',
                instructorsAndAdmins: 'Instructors & Admins',
                addUser: 'Add user',
                enterEmailToInvite: 'Enter email address to invite',
                emailAlreadyInUse: 'This email address is already in use.',
                inviteSent: 'Invite sent',
                organizationInviteEmailSent: 'An organization invite has been sent to {email}.',
                editUser: 'Edit user',
                enterUserFirstName: 'Enter the first name of the user',
                enterUserLastName: 'Enter the last name of the user',
                rolesExplanation:
                    'Only admins can add instructors to the simulation. Both admins and instructors can create simulations, invite participants, and manage and run the simulations.',
                searchByNameOrEmail: 'Search by name or email',
                role: 'Role',
                adminRole: 'Admin',
                instructorRole: 'Instructor',
                participantRole: 'Participant',
                inviteFailedDescription: 'The invite link could not be sent to the user.',
                confirmRemoveUsersFromOrganization:
                    'Unused | Are you sure you want to remove this user from the organization? | Are you sure you want to remove these {count} users from the organization?',
                removeUsersFromOrganization: 'Remove user from organization | Remove users from organization',
                removeFromOrganization: 'Remove from organization',
                userTaskAttemptsReset: 'User task attempts have been reset.',
                department: 'Department',
                departmentRole: 'Department role',
                departmentAdminRole: 'Department Admin',
                importUsers: 'Import users',
                downloadTemplate: 'Download template',
                importSuccess:
                    'Bulk user invite was successfully sent. Please note that users have to accept the invite to be added to the organization and be shown in the users list.',
                successNotificationTitle: 'Users invited successfully',
                name: 'Name',
                email: 'Email',
                searchPlaceholder: 'Search by name or email',
                importUsersHint:
                    'Download the template to import users. The template is a CSV file that you can fill in with the required information to bulk invite users to your organization. Once you have filled in the template, you can upload it to bulk invite the users. They will appear on your dashboard once they have responded to your invite',
            },
            settings: {
                title: 'Settings',
                account: 'Account',
                general: 'General',
                security: 'Security',
                updateAccount: 'Update account',
                waitingForConfirmation: 'Waiting for confirmation',
                cannotChangeEmailUntilRequestFulfilled:
                    'Your email address can not be changed back to your original email until the current change request is fulfilled or it expires.',
                afterUpdateReceiveEmail:
                    'After updating your email address, you will receive an email to confirm the change.',
                accountHasBeenUpdated: 'Your account has been updated.',
                passwordHasBeenUpdated: 'Your password has been updated.',
                emailHasBeenChanged: 'Your email address has been changed.',
                pleaseCheckEmail: 'Please check your email to confirm the change of your email address.',
            },
            documentsManagement: {
                uploadDocuments: 'Upload documents',
                description: 'Manage the documents and resources uploaded by the organization.',
                file: 'File',
                department: 'Department',
                departmentRole: 'Department role',
                competencyCluster: 'Competency cluster',
                competency: 'Competency',
                searchByPlaceholder: 'Search Documents',
                document: 'documents',
                language: 'Language',
                languagePlaceholder: 'Select a language',
                confirmDeleteDocuments:
                    'Are you sure you want to delete this document? | Are you sure you want to delete these {count} documents?',
                deleteDocuments: 'Delete documents',
            },
        },
        auth: {
            login: 'Login',
            signInWithEmail: 'Sign in with your email address and password',
            letsGetStarted: "Let's get started!",
            createANewAccount: 'Create a new account',
            alreadyHaveAnAccount: 'Already have an account?',
            dontHaveAnAccountYet: "Don't have an account yet?",
            weSentConfirmationEmail:
                'We have sent you a confirmation email. Please check your inbox and click on the link to confirm your account.',
            emailAddress: 'Email address',
            emailAddressRequired: 'Email address*',
            enterEmail: 'Enter your email address',
            password: 'Password',
            enterPassword: 'Enter your password',
            forgotPassword: 'Forgot password?',
            forgotPasswordCap: 'Forgot Password?',
            signIn: 'Sign in',
            signUp: 'Sign up',
            requestEmailToResetPassword: 'Request email to reset your password',
            passwordResetSuccessMessage:
                'We have sent you an email with instructions to reset your password. Check your inbox to continue or {0}!',
            rememberPassword: 'Remember your password?',
            signInHere: 'Sign in here',
            goBack: 'go back',
            resetPassword: 'Reset password',
            resetPasswordCap: 'Reset Password',
            chooseNewPassword: 'Choose a new password for your account',
            passwordChangedSuccessMessage: 'You have successfully changed your password. You can now {0}!',
            signInAgain: 'sign in again',
            setupAccount: 'Setup account',
            setupAccountCap: 'Setup Account',
            youHaveInvitation: 'You have been invited to create an account',
            firstName: 'First name',
            enterFirstName: 'Enter your first name',
            lastName: 'Last name',
            enterLastName: 'Enter your last name',
            newPassword: 'New password',
            enterNewPassword: 'Enter your new password',
            confirmNewPassword: 'Confirm new password',
            enterNewPasswordAgain: 'Enter your new password again',
            updatePassword: 'Update password',
            passwordRequirements: 'Password requirements',
            mustMeetPasswordRequirements:
                'To create a new password, you have to meet all of the following requirements:',
            passwordRequirementLength: 'At least 8 characters',
            passwordRequirementDigit: 'At least 1 digit',
            passwordRequirementSpecialCharacter: 'At least 1 special character',
            welcome: 'Welcome!',
            enterAccessCodeToSimulation: 'Enter the code to access the simulation',
            enterAccessCode: 'Enter the access code',
            haveAnAccount: 'Have an account?',
            weArePreparingSimulation: 'We are preparing your simulation',
            emailAlreadyInUse: 'Account with this email already exists',
        },
        organizations: {
            joinOrganization: 'Join organization',
            youWereInvitedToJoin: 'You were invited to join',
            ifYouAcceptJoinWith: 'If you accept the invite you will join this organization as {email}',
            joinWithAnotherAccount: 'Join with another account',
            youNeedToBeLoggedIn: 'You need to be logged in to join the organization.',
            signInWithAnExistingAccount: 'Sign in with an existing account',
            createANewAccount: 'Create a new account',
        },
        simulation: {
            navigation: {
                collapse: 'Collapse',
                exitSimulation: 'Exit simulation',
            },
            taskInfo: {
                moreInformation: 'More information about this task',
            },
            notifications: {
                alerts: 'Alerts',
                noAlerts: 'No alerts',
                emails: 'Emails',
                noEmails: 'No emails',
                nextNews: 'Next news',
                previousNews: 'Previous news',
                more: 'more',
            },
            presence: {
                adjectives: ['Fluffy', 'Happy', 'Mighty', 'Clever', 'Brave', 'Wise', 'Quiet', 'Smart', 'Friendly'],
                animals: ['Penguin', 'Dolphin', 'Elephant', 'Koala', 'Panda', 'Rabbit', 'Fox', 'Owl'],
            },
            defaultPeriodNaming: {
                singular: {
                    atSentenceStart: 'Period',
                    inSentence: 'period',
                },
                plural: {
                    atSentenceStart: 'Periods',
                    inSentence: 'periods',
                },
            },
            decisions: {
                submission: {
                    currentSubmission: 'Current submission',
                    previousSubmissions: 'Previous submissions',
                    title: 'Summary',
                    subtitle:
                        "Here's a recap of the decisions you have made in this {inSentence} and how they compare to the last {inSentence}!",
                    changes: '1 change | {count} changes',
                    editDecisions: 'Edit decisions',
                    confirmSubmission: 'Confirm submission',
                    successNotification: {
                        title: 'Submission successful!',
                        text: 'You have successfully submitted your decisions for this {inSentence}.',
                    },
                    invalidNotification: {
                        title: 'Submission not possible!',
                        text: 'There are some errors in your submission that you need to fix first.',
                    },
                    taskSubmissionError: 'An error occurred while submitting the task. Please try again.',
                    clickToSeeTaskDescription: 'Click to see the task description',
                },
                sliderDecision: {
                    level: 'Level {level}',
                },
                multiSelectDecision: {
                    subtitle: 'You can select up to 1 option | You can select up to {count} options',
                    summary: {
                        noOptionsSelected: 'No options selected',
                    },
                },
                chooseAndMapDecision: {
                    expand: 'Details',
                    collapse: 'Collapse',
                },
                conversationDecision: {
                    conversationTitle: 'Conversation',
                    emptyChatMessage:
                        'At each next step in the conversation, you will be able to see the conversation flow up to the last step here based on the responses you rank as 1 at each step.',
                    messageCount: 'Message {current}/{total}',
                },
                resourceAllocationDecisoin: {
                    availableBudget: 'Available budget: {budget}',
                    totalBudget: 'Total budget: {budget}',
                },
                selectWithStakeholderStanceDecision: {
                    stakeholderStance: 'Stakeholder stance',
                    stakeholderStanceOn: 'Stakeholder stance on {title}',
                },
                roleAssignmentDecision: {
                    role: 'Role',
                    jobDescription: 'Job description',
                    keyDeliverables: 'Key deliverables',
                    rankTeamMembersFromTo:
                        'Rank the team members listed below from 1 to {count} based on their suitability for the above role. Full team profiles are available in the Control Room.',
                    interestByTeamMembers: 'Interest by team members',
                },
                stakeholderMessage: {
                    viewMessages: 'View messages',
                    selectStakeholder: 'Please select a Stakeholder',
                    selectTheMostAppropriateMessageFor:
                        'Select the most appropriate message for {title} from the options given below:',
                },
                table: {
                    decisionColumnHeader: 'Decision',
                    submissionPending: 'Submission pending',
                },
                validation: {
                    pleaseFillOut: 'Please fill out this field.',
                    valueShouldBeBetween: 'The value should be between {min} and {max}.',
                },
                aiConversation: {
                    conversationEnded: 'This stage of interaction has now ended.',
                },
                rank: 'Rank',
                text: {
                    answer: 'Enter your answer here...',
                },
            },
            performance: {
                metrics: 'Metrics',
                dashboardMetricTable: {
                    allTeams: 'All teams',
                    percentageChangeColumnHeader: '% Change',
                    toggleRow: 'Toggle {title} row',
                    less: 'Less',
                },
                metricCard: {
                    tabModes: {
                        latest: 'Latest',
                        change: 'Change',
                        trends: 'Trends',
                        competitiors: 'Competitors',
                    },
                    availableAfterFirstPeriod: 'Available after the first {inSentence}',
                    analyze: 'Analyze',
                },
                strategicObjectives: {
                    dropDownPlaceholder: 'Strategic objective',
                    metrics: 'Strategic objective metrics',
                    searchAMetric: 'Search for a metric',
                    noMatchingMetrics: 'No matching metrics',
                    none: 'None',
                    pathColorHint: 'The green-highlighted cards below form a part of the selected objective',
                },
            },
            teamSelection: {
                instructorMode: 'Instructor mode',
                asTeam: 'As Team',
            },
            simulationManagementCard: {
                startPeriod: 'Start {inSentence}',
                calculatePeriod: 'Calculate {inSentence}',
                calculatingPeriod: 'Calculating ...',
                sendReports: 'Send reports',
                sendingReports: 'Sending ...',
                viewAccessCodes: 'View access codes',
                endSimulation: 'End simulation',
                simulationStatus: {
                    canBeStarted: '{atSentenceStart} ready to be started!',
                    allSubmitted: 'All teams have submitted their decisions',
                    nTeamsHaveSubmitted: '{submissionCount}/{teamCount} teams have submitted their decisions',
                    waitingForNextPeriod: 'Waiting for next {inSentence}',
                    decisionsPending: 'Your decisions are pending!',
                    investigateOutcomes: 'Investigate news and performance outcomes',
                },
                sendReportsNotificationText: 'Reports have been sent to the participants',
                timeOver: 'Time over! Taking you to the next quest.',
                timeLeft: 'Time left: {timeLeft}',
            },
            infoSlidesModal: {
                information: 'Information',
                duration: 'Duration: {duration}',
                switchToReadMode: 'Switch to read mode',
                videoPlay: 'Play',
            },
            helpModal: {
                instructorHandbookTitle: "Instructor's Handbook",
                participantHandbookTitle: "Manager's Handbook",
            },
            newResultsNotification: {
                title: 'New results',
                text: '{atSentenceStart} results are now available.',
            },
            newDecisionsNotification: {
                title: 'New {inSentence} decisions',
                text: 'You can now add decisions for the new {inSentence}.',
            },
            assessments: {
                competenceAssessments: 'Competence Assessments',
                assessmentWillBeGenerated: 'Assessments will be generated once the simulation is completed.',
                loadingAssessments: 'Loading assessments ...',
                competency: 'Competency',
            },
        },
        fontSize: {
            groupTitle: 'Text size',
            0: 'Regular',
            1: 'Large',
            2: 'Very large',
        },
        language: {
            groupTitle: 'Language',
            multi: 'Multilingual',
            ar: 'العربية',
            bg: 'български',
            cs: 'Čeština',
            de: 'Deutsch',
            en: 'English',
            es: 'Español',
            fr: 'Français',
            hr: 'Hrvatski',
            hu: 'Magyar',
            id: 'Bahasa Indonesia',
            it: 'Italiano',
            ja: '日本語',
            nl: 'Nederlands',
            pl: 'Polski',
            pt: 'Português',
            ro: 'Română',
            sk: 'Slovenčina',
            sl: 'Slovenščina',
            sr: 'Српски',
            th: 'ไทย',
            vi: 'Tiếng Việt',
            'zh-Hans': '简体中文',
            'zh-Hant': '繁體中文',
        },
        theme: {
            groupTitle: 'Theme',
            auto: 'Auto',
            light: 'Light',
            dark: 'Dark',
        },
        errors: {
            error: 'Error',
            timeout: 'Timeout',
            unauthorized: 'Unauthorized',
            somethingWentWrong: 'Something went wrong!',
            pleaseTryAgainOrContactSupport: 'Please try again or contact support.',
            noPageHere: "There's no page here!",
            looksLikeYouEndedHereByAccident: 'Looks like you ended up here by accident?',
            returnToStart: 'Return to start',
            // Frontend error messages
            frontend: {
                general: 'Something went wrong!',
                simulationEndedAutomaticSignOut: 'The simulation has ended! You have been signed out automatically.',
                simulationFetchFailed: 'Could not get simulation!',
                simulationNotLoaded: 'The simulation is not loaded',
                simulationNotProvided: 'The simulation can not be accessed',
                signInFailed: 'Failed to sign in',
                signUpFailed: 'Failed to sign up',
                userAlreadyExists: 'User already exists',
                signOutFailed: 'Failed to sign out',
                notSignedIn: 'You are not signed in',
                currentEmailFetchFailed: 'Could not get the current email address',
                passwordUpdateFailed: 'Failed to update password',
                scenariosFetchFailed: 'Could not get scenarios',
                simulationsFetchFailed: 'Could not get simulations',
                simulationCountFetchFailed: 'Could not get the number of simulations',
                simulationSaveFailed: 'Could not save simulation',
                simulationArchiveFailed: 'Could not archive simulation',
                simulationDeleteFailed: 'Could not delete simulation',
                simulationRestoreFailed: 'Could not restore simulation',
                teamFetchFailed: 'Could not get team',
                teamsFetchFailed: 'Could not get teams',
                teamsSaveFailed: 'Could not save teams',
                teamsDeleteFailed: 'Could not delete teams for simulation',
                decisionSubmitFailed: 'Could not submit decisions',
                simulationUserRoleFetchFailed: 'Could not get simulation user role',
                userSaveFailed: 'Could not save user',
                usersFetchFailed: 'Could not get users',
                usersDeleteFailed: 'Could not delete users',
                currentUserFetchFailed: 'Could not get current user',
                loadFilesFailed: 'Could not load files',
                uploadFileFailed: 'Could not upload file',
                deleteFileFailed: 'Could not delete file',
                challengesFetchFailed: 'Could not get challenges',
                challengeUpdateFailed: 'Could not update challenge',
                assessmentsFetchFailed: 'Could not get assessments',
                userNotLoggedIn: 'User is not logged in',
                userCourseAssignmentsFetchFailed: 'Could not get user course assignments',
                coursesFetchFailed: 'Could not get courses',
                courseRelationsFetchFailed: 'Could not get course relations',
                userTaskAttemptFetchFailed: 'Could not get latest user activity attempt',
                scenarioTranslationError: 'An error occurred while translating the scenario. Please try again.',
                organizationCountFetchFailed: 'Could not get the number of organizations',
                organizationSaveFailed: 'Could not save organization',
                organizationBrandingSaveFailed: 'Could not save organization branding',
                organizationUpdateFailed: 'Could not update organization',
                organizationsFetchFailed: 'Could not get organizations',
                organizationAlreadyExists: 'Organization already exists',
                organizationCreateFailed: 'Could not create organization',
                organizationFetchFailed: 'Could not get organization',
                invalidInviteId: 'This invitation link is invalid or has expired. Please request a new one.',
                inviteAlreadyUsed:
                    "This invitation has already been used. Please login with your existing account. Please reset password if you don't remember your current password.",
            },
            edgeFunctions: {
                // Edge functions 4XX error messages
                userNotAdmin: 'User is not an admin. Only admins can perform this action.',
                userNotInstructor: 'User is not an instructor. Only instructors can perform this action.',
                userNotFound: 'Could not get user',
                simulationNotFound: 'Simulation not found',
                teamNotFound: 'Team not found',
                missingTeamDecisions: 'Not all teams submitted their decisions',
                invalidAccessCode: 'The access code is invalid',
                simulationEnded: 'The simulation has already ended',
                simulationNotStarted: 'The simulation has not started yet',
                userUnauthorizedChangeMail: 'User is not authorized to change email',
                requestMissingForm: 'Request is missing form',
                incompleteRequestData: 'Missing request data',
                userAlreadyExists: 'User already exists',
                periodAlreadyStarted: 'The period is already started',
                userAlreadyInOrganization: 'You are already a member of this organization',
                // Edge functions 5XX error messages
                couldNotProcess: 'An error occurred while processing your request',
                userCreateFailed: 'An error occurred while creating the user',
                roleSetFailed: 'Could not set role',
                passwordResetEmailSendFailed: 'An error occurred while sending password reset email',
                inviteEmailSendFailed: 'An error occurred while sending invite emails',
                emailChangeEmailFailed: 'An error occurred while sending email to confirm email change',
                reportEmailsSendFailed: 'An error occurred while sending report emails',
                scenarioDefinitionNotFound: 'Scenario definition not found',
                simulationNotFinished: 'Simulation is not finished',
                invalidJwt: 'There is something wrong with your access link. Please request a new one.',
                expiredJwt: 'Your access link has expired. Please request a new one.',
            },
        },
        validation: {
            mixed: {
                required: 'Please fill out this field.',
            },
            string: {
                email: 'Please enter a valid email address.',
                min: 'Please enter at least ${min} characters.',
                max: 'Please enter no more than ${max} characters.',
                length: 'Please enter exactly ${length} characters.',
                atLeastOneNumber: 'Please incorporate at least one number.',
                atLeastOneSpecialCharacter: 'Please incorporate at least one special character.',
                passwordsMatch: 'Passwords must match.',
            },
            boolean: {
                isValue: '${path} field must be ${value}',
                acceptTos: 'Please accept the terms of service and privacy policy.',
            },
        },
        table: {
            perPage: '{count} per page',
            filters: 'Filters',
            clearFilters: 'Clear filters',
            any: 'Any',
            noMatchesFound: 'No matching {item} found!',
            noItemsExist: 'There are no {item} yet!',
            noActionsDefined: 'No actions defined.',
            applyFilter: 'Apply filter | Apply filters',
        },
        wizard: {
            stepOf: 'Step {step} of {total}',
        },
        smartInstructor: {
            smartInstructor: 'Smart Instructor',
            resetChat: 'Reset chat',
            failedToSendRetry: 'Failed to send! Click here to retry',
            respondingDots: 'Responding ...',
            askMeAQuestionDots: 'Ask me a question ...',
            suggestions: 'Suggested questions',
            moreInsights: 'More insights',
            typeResponseDots: 'Type your response...',
        },
        cookieNotice: {
            title: 'Data Collection Consent',
            description:
                'We use essential digital markers and analytics tools to enhance functionality and improve our service. Your privacy is important to us. You have the option to accept these tools or reject them.',
            decline: 'Reject',
            accept: 'Accept',
        },
        demo: {
            finishDemo: 'Finish demo',
            auth: {
                title: 'Welcome!',
                subtitle: 'Submit the form below for an access link to our demo simulation',
                name: 'Name',
                enterName: 'Enter your name',
                organization: 'Organization',
                enterOrganization: 'Enter your organization',
                getAccessLink: 'Get access link',
                tosDescription1: 'I agree to the ',
                tosLink: 'terms of service',
                tosDescription2: ' and have read the ',
                privacyPolicyLink: 'privacy policy',
                checkInboxForAccessLink:
                    'We sent you an email with a link to access the demo. Please check your inbox.',
            },
            scenarioSelection: {
                welcomeToDemo: 'Welcome to our demo simulation!',
                description:
                    'Our simulations cover a wide range of functional areas and industries. This demo focuses on sales productivity.',
                greatExperience: 'We hope you have a great experience exploring it!',
                startSimulation: 'Start the simulation',
            },
            useCases: {
                enjoyedDemo: 'Enjoyed the demo? There is more!',
                wideRange: 'Our simulations cover a wide range of cuntional areas and industries.',
                someExamples: 'Here are some examples:',
                leadershipDevelopment: {
                    title: 'Leadership Development',
                    description: 'Build impactful leaders to manage complex challenges',
                },
                financialAcumen: {
                    title: 'Financial Acumen',
                    description: 'Empower managers to drive fiscal success',
                },
                businessManagement: {
                    title: 'Business Management',
                    description: 'Cultivate management talent for organizational growth',
                },
                salesProductivity: {
                    title: 'Sales Productivity',
                    description: 'Boost sales productivity and buid high performing sales team',
                },
                cashFlowManagement: {
                    title: 'Cash Flow Management',
                    description: 'Optimize liquidity management for sustainable growth',
                },
                riskManagement: {
                    title: 'Risk Management',
                    description: 'Build talent to place smart bets and mitigate risk across your company',
                },
                lookingForDifferentUseCase: 'Looking for a different use case?',
                canBeExtended: 'Our simulations can be extended to meet your specific requirements',
                getInTouch: 'Get in touch with us to transform you organization!',
                contactUs: 'Contact us',
            },
        },
        mobileView: {
            heyThere: 'Hey there!',
            looksLikeMobile: "Looks like you're using a mobile device or a zoomed in desktop screen!",
            mobileNotSupported:
                'Our platform is currently configured for a desktop-based experience. <br /><br />Accessing it on your device could compromise the user experience and access to mandatory information and interactions. <br /><br />Do you still want to continue?',
            backToHomepage: 'Proceed',
            contactUs: 'Or contact us for help at {contactEmail}',
        },
        cms: {
            saveActivity: 'Save activity',
            activity: 'activity',
            listView: 'as List',
            cardsView: 'as Cards',
            goToCoursesPage: 'Go to the courses page',
            continueEditing: 'Continue editing',
            activityCreateSuccess: 'Activity created successfully',
            selectActivityType: 'Select Activity Type',
            addNew: 'Add new',
            addTopic: 'Add topic',
            addSubtopic: 'Add sub-topic',
            addTask: 'Add activity',
            addSubtopicUnder: 'Add sub-topic under {topic}',
            editDetails: 'Edit details - {topic}',
            addActivity: 'Add activity',
            activityName: 'Activity name',
            topicName: 'Title',
            topicNamePlaceholder: 'Short title to be shown for this topic (2-3 words)',
            topicDescription: 'Description',
            topicDescriptionPlaceholder: 'Short description to be shown for this topic (8-10 words)',
            topicImage: 'Image',
            title: 'Title',
            icon: 'Icon',
            baseInformation: 'Base information',
            activityObjective: 'Objective',
            activityObjectivePlaceholder: 'What is the purpose of this activity?',
            activityTitlePlaceholder: 'The title shown to the user',
            description: 'Description',
            activityDescriptionPlaceholder: 'The description shown to the user',
            image: 'Image',
            displayInformation: 'Display Information',
            displayInformationInfo: 'Following information will be shown to the end-user.',
            backgroundInformation: 'Background Information',
            backgroundInformationInfo:
                'Following information will be used to evaluate the activity. It will not be shown to the end-user.',
            activityImagePlaceholder: 'An optional image for the activity card',
            activityTitle: 'Activity Title',
            activityDescription: 'Activity Subtitle',
            activityImage: 'Activity Image',
            activityIntroContent: 'Activity Introduction',
            activityIntroContentPlaceholder: 'Shown before the start of the activity',
            enterContentPlaceholder: 'Enter content here...',
            addAnotherResource: 'Add a resource',
            activityAdditionalInfoForEvaluation: 'Additional Information for Evaluation',
            activityAdditionalInfoForEvaluationPlaceholder:
                'Information that is useful in evaluating the activity can be added here.',
            file: 'File',
            informationComponentsHint:
                'Information components include the information that the user sees in the activity page.',
            interactionComponentsHint: 'Interaction components are used for taking the user input for the activity.',
            showTour: 'Show tour',
            learning: 'Learning activity',
            assessment: 'Assessment activity',
            resource: {
                searchIconPlaceholder: 'Search for an icon',
                name: 'Name',
                namePlaceholder: 'Enter a name for this resource',
                content: 'Content',
                contentPlaceholder: 'Enter the content for this resource',
                icon: 'Icon',
                iconPlaceholder: 'Select an icon for this resource',
                type: 'Type',
                typePlaceholder: 'Select the type of resource you would like to add',
                externalContent: 'External content',
            },
            fileUpload: {
                chooseFile: 'Choose file',
                chooseDifferentFile: 'Choose a different file',
                selectAlreadyUploadedFile: 'Select from already uploaded files',
                selectDifferentFile: 'Select a different already uploaded file',
            },
            decisions: {
                general: {
                    resources: 'Resources',
                    content: 'Content',
                    addContentForRandomization: 'Add another content for randomization',
                    tryPreview: 'Try out the preview!',
                    preview: 'Preview',
                    evaluationCriteria: 'Competencies to Evaluate',
                    evaluationCriteriaDescription:
                        'Provide the skill or competencies that the user should be evaluated on through this activity. For each criterion provide the attributes on which feedback should be provided to the user.',
                    competency: 'Competency',
                    competencyPlaceholder: 'Select a competency',
                    competencyAttribute: 'Attributes to evaluate for this competency',
                    competencyAttributePlaceholder: 'Enter attributes to evaluate for this competency',
                    addCompetency: 'Add another competency',
                    scoringScheme: 'Scoring scheme',
                    percentage: 'Percentage',
                    rating: 'Rating (e.g. 1-5)',
                    bestRating: 'Best rating',
                    optional: 'optional',
                    addOptionText: 'Add option text',
                    addOption: 'Add another option',
                    askAI: 'Ask AI',
                },
                aiConversation: {
                    objective: 'Conversation objective',
                    objectivePlaceholder: 'What should be achieved by means of this role-play conversation?',
                    context: 'Conversation Framework',
                    contextPlaceholder:
                        'Is there a pre-defined framework of conversation strategies or approaches that should be applied to this conversation? If yes, please provide it here',
                    rulesAndGuidelines: 'Rules & Guidelines',
                    rulesAndGuidelinesPlaceholder: 'Provide a list of rules to be followed during the conversation',
                    aiprofile: 'AI Profile',
                    profileName: 'Name',
                    profileNamePlaceholder: 'What name should be given to the AI bot?',
                    profile: 'Role',
                    profilePlaceholder:
                        'What role should be played by the AI bot in this scenario? Briefly describe its main characteristics',
                    avatar: 'Avatar',
                    conversationScenario: 'Conversation Scenario',
                    scenarioDescription: 'Situation',
                    scenarioDescriptionPlaceholder:
                        'Describe the specific situation to be addressed in the conversation.',
                    additionalScenarioInfo: 'Additional Info',
                    additionalScenarioInfoPlaceholder:
                        'Include any scenario-specific attributes, such as the best strategy, interpersonal skills etc. to apply to handle this scenario',
                    addAnotherScenario: 'Add another scenario instance for randomisation',
                    mode: 'Conversation mode',
                    textMode: 'Text',
                    speechMode: 'Speech',
                    hybridMode: 'Hybrid',
                    voice: 'Voice',
                    voice_echo: 'Echo (male)',
                    voice_nova: 'Nova (female)',
                },
                report: {
                    addText: 'Add text here...',
                    addSection: 'Add another section',
                    addQuestion: 'Add another question',
                    sections: 'Sections',
                    title: 'Title',
                    sectionTitlePlaceholder: 'Enter the section title',
                    questions: 'Questions',
                    questionTitlePlaceholder: 'Enter the question',
                    allowUserDefinedQuestions: 'Allow the user to add their own questions/topics',
                    addAnotherRow: 'Add another row',
                    addTitle: 'Add title',
                },
                assignment: {
                    assignmentInstruction: 'Assignment Instruction',
                    assignmentInstructionPlaceholder:
                        'Assignment instruction to give to users for dragging and dropping cards',
                    assignmentTheme: 'Assignment Theme',
                    assignmentThemePlaceholder: 'The topic/theme to show for the items to assign (2-3 words) ',
                    categories: 'Categories',
                    categoryPlaceholder: 'Add the name of the category (1-2 words)',
                    addCategory: 'Add another category',
                    items: 'Items',
                    item: 'Item',
                    text: 'Text',
                    description: 'Description',
                    category: 'Category',
                    itemTextPlaceholer: 'Text to show on the item card',
                    itemDescriptionPlaceholder: 'Optional, can be accessed as a hint',
                    itemCategoryPlaceholder: 'Select the category this item belongs to',
                    addItem: 'Add another item',
                    correctOption: 'Correct option',
                    minAssignments: 'Min. assignments per category',
                    maxAssignments: 'Max. assignments per category',
                    randomizeOptionsCount: 'Randomize options count',
                },
                ranking: {
                    rankOptionsTitle: 'Options in correct ranking order',
                },
                text: {
                    questionPlaceholder: 'Add question/title',
                    short: 'Short',
                    long: 'Long',
                    addQuestion: 'Add question',
                },
                image: {
                    source: 'URL',
                    alt: 'Alternative text',
                    altPlaceholder: 'Alternative text for the image',
                },
                video: {
                    source: 'URL',
                },
                checkbox: {
                    options: 'Options',
                    correct: 'Correct?',
                    checkboxItemContentPlaceholder: 'Add checkbox item content',
                },
                multipleChoice: {
                    options: 'Options',
                    correct: 'Correct?',
                    multipleChoiceItemContentPlaceholder: 'Add multiple choice item content',
                },
                table: {
                    columns: 'Columns',
                    columnPlaceholder: 'Add the name of the column (1-2 words)',
                    addColumn: 'Add another column',
                    columnHintPlaceholder: 'Add a hint for the column',
                    rowGroups: 'Row groups',
                    rowGroupTitlePlaceholder: 'Add the name of the row group (1-2 words)',
                    addRowGroup: 'Add another row group',
                    rowGroupHintPlaceholder: 'Add a hint for the row group',
                    rows: 'Rows',
                    rowPlaceholder: 'Add the name of the row (1-2 words)',
                    rowHintPlaceholder: 'Add a hint for the row',
                    addRow: 'Add another row',
                    allowUserDefinedRows: 'Allow the user to add their own rows',
                    addRowwiseTotalCell: 'Add a row-wise total cell',
                    addColumnwiseTotalCell: 'Add a column-wise total cell',
                    text: 'Text Input',
                    staticText: 'Static Text',
                    number: 'Number Input',
                    select: 'Dropdown Input',
                    total: 'Total',
                    numberPlaceholder: '0',
                    formula: 'Formula Input',
                    columnSuffixPlaceholder: 'Add a suffix for the column',
                    options: 'Options',
                    optionPlaceholder: 'Add the name of the option (1-2 words)',
                    addSelectOption: 'Add another dropdown option',
                    addStaticText: 'Add another static text',
                },
            },
        },
    },
};
